import axios from 'axios';
import ParametricResult from '../parametric/templates/result';

class FlatType {
    constructor(options) {
        this.options = options;
        this.element = options.element;
        this.loader = this.element.querySelector('.loader');
        this.groupInfoBack = null;
        this.result = null;

        this.getParams = new URLSearchParams();
        this.incomeData = '';
    }

    async init() {
        this._initResult();
        await this._getDataForGroup();
        this._initGoBackToFlat();
        this._setPriorityFlat();
    }

    /**
     * Инициализация результатов
     * @private
     */
    _initResult() {
        this.result = new ParametricResult({
            isFlatType: true,
            element   : this.element,
            changeSort: async(data) => {
                await this._send('sort', data);
            },
            changeHasDiscount: async(data) => {
                await this._send('filter', data);
            },
            clickMore: async(data) => {
                await this._send('more', data);
            },
            changeGroupInfo: async(data) => {
                await this._send('groupInfo', data);
            },
            change: async(data) => {
                await this._send('more', data);
            },
            changeGroup: () => {
                return null;
            },
            updateFilterGroupCheckbox: () => {
                return null;
            },
            setActiveFilter: () => {
                return null;
            }
        });

        this.result.init();
    }

    /**
     * Получение данных по группе
     * @private
     */
    async _getDataForGroup() {
        this.incomeData = new URLSearchParams(document.location.search);

        const groupExpandId = this.incomeData.get('groupExpandId');
        const priorityFlatId = this.incomeData.get('flat-id');

        if (groupExpandId && priorityFlatId) {
            await this._send('groupInfo');
        } else {
            if (this.loader?.style) {
                this.loader.style.display = 'none';
            }
            this.result._setNoResults(true);
        }
    }

    /**
     * Приоритезация квартиры в выдаче
     * @private
     */
    _setPriorityFlat() {
        const priorityId = this.incomeData.get('flat-id');
        let priorityFlat = null;
        let priorityFlatMobile = null;

        if (this.result.groupInfoWrapper) {
            priorityFlat = this.result.groupInfoWrapper.querySelector(`
                .parametric-group-flat[data-id="${priorityId}"]
            `);
            priorityFlatMobile = this.result.groupInfoWrapper.querySelector(`
                .parametric-group-flat-mobile[data-id="${priorityId}"]
            `);
        }

        if (priorityFlat) {
            priorityFlat.classList.add('parametric-group-flat_theme_priority');
        }

        if (priorityFlatMobile) {
            priorityFlatMobile.classList.add('parametric-group-flat_theme_priority');
        }
    }

    /**
     * Запрос на сервер
     * @param {string} reqType - тип запроса
     * @private
     */
    /* eslint-disable max-lines-per-function, max-statements */
    async _send(reqType = 'groupInfo', additionalData = {}) {
        if (reqType !== 'groupInfo') {
            return;
        }

        if (this.loader?.style) {
            this.loader.style.display = 'flex';
        }

        const formData = new FormData();
        const method = this.element.dataset['method'] || 'post';
        const action = this.element.dataset['action'] || '/api/estate-search/results';

        formData.append('sort', this.result.sortGroupInput || 'priceDesc');
        formData.append('groupId', this.incomeData.get('groupExpandId') || '');
        formData.append('request_type', reqType);

        // Hidden params
        formData.append('ts', this.element.dataset.appendTs || '');
        formData.append('st', this.element.dataset.appendSt || '');
        formData.append('mf', this.element.dataset.appendMf || '');

        this._addAdditionalData(formData, additionalData);

        this.result.runLoading();

        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        await axios[method](action, formData)
            .then((response) => {
                const {data, success, messages} = response.data;

                if (!success) {
                    throw new Error(messages.length ? messages : 'Ошибка на сервере');
                }

                if (formData.get('sortGroup')) {
                    this.result.setGroupFlatsList(data, true);
                } else {
                    this.result.setResultGroupInfo(data);
                    this.result.initGroupSortSelect();
                }
            })
            .catch((error) => {
                console.error(error);
            })
            .then(() => {
                this.result.stopLoading();
                this._setPriorityFlat();
            })
            .finally(() => {
                if (this.loader?.style) {
                    this.loader.style.display = 'none';
                }
            });
    }
    /* eslint-enable max-lines-per-function, max-statements */

    /**
     * Добавляет дополнительные данные в данные формы
     * @param {object} formData - formData
     * @param {object} data - объект доп. данных (может содержать данные формы)
     * @private
     */
    _addAdditionalData(formData, data) {
        if (!data) {
            return;
        }

        Object.keys(data).forEach((key) => {
            if (data[key] instanceof FormData) {
                data[key].forEach((v, k) => {
                    formData.append(k, v);
                });
            } else if (data[key] instanceof Array) {
                data[key].forEach((el) => {
                    formData.append(key, el);
                });
            } else {
                formData.append(key, data[key]);
            }
        });
    }

    _initGoBackToFlat() {
        this.groupInfoBack = document.querySelector('.j-group-info__back');

        if (this.groupInfoBack) {
            this.groupInfoBack.addEventListener('click', () => {
                const id = this.incomeData.get('flat-id');

                window.location.replace(`/flats/${id}`);
            });
        }
    }
}

export default FlatType;
